package com.wintermar.inspection

import app.cash.sqldelight.Transacter
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import com.wintermar.inspection.composeApp.newInstance
import com.wintermar.inspection.composeApp.schema
import kotlin.Unit

public interface AppDatabase : Transacter {
  public val answerChunkFileTableQueries: AnswerChunkFileTableQueries

  public val answerFileTableQueries: AnswerFileTableQueries

  public val answerLocationTableQueries: AnswerLocationTableQueries

  public val answerSelectionTableQueries: AnswerSelectionTableQueries

  public val answerTableQueries: AnswerTableQueries

  public val inspectionTableQueries: InspectionTableQueries

  public val sqliteVersionQueries: SqliteVersionQueries

  public val templateOptionTableQueries: TemplateOptionTableQueries

  public val templatePageSectionQuestionTableQueries: TemplatePageSectionQuestionTableQueries

  public val templatePageSectionTableQueries: TemplatePageSectionTableQueries

  public val templatePageTableQueries: TemplatePageTableQueries

  public val templateTableQueries: TemplateTableQueries

  public val vesselTableQueries: VesselTableQueries

  public companion object {
    public val Schema: SqlSchema<QueryResult.Value<Unit>>
      get() = AppDatabase::class.schema

    public operator fun invoke(driver: SqlDriver): AppDatabase = AppDatabase::class.newInstance(driver)
  }
}
